module.exports = __webpack_public_path__ + "img/powr.1a1541ff.svg";